import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components/macro";
import { COOKIE_TYPES } from "../../enums/cookies";
import { startSurvicate } from "../../services/survicate.service";
import { gdprCookieHasValue } from "../../utils/cookieUtils";

const MainWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

const SurvicateWrapper: React.FunctionComponent<any> = ({ children }) => {
    useCreateSurvicate();

    return <MainWrapper>{children}</MainWrapper>;
};

function useCreateSurvicate() {
    const location = useLocation();

    const hasAnalyticsConsent = gdprCookieHasValue(COOKIE_TYPES.ANALYTICS);

    useEffect(() => {
        const disableSurvicate =
            location.pathname.includes("/result") ||
            location.pathname.includes("/unauthorized") ||
            location.pathname.includes("/auth");

        if (disableSurvicate || !hasAnalyticsConsent) {
            return;
        }

        startSurvicate();
    }, [hasAnalyticsConsent, location.pathname]);
}

export default SurvicateWrapper;
